import FingoMuiFilledInput from '../../fingo/components/MuiFilledInput';
import DEFAULT_FILLED_INPUT_CLASS_NAME from '../../constants/filled-input';

const getDefaultFilledInputStyles = ({ theme }) => ({
  '& .MuiSvgIcon-root': {
    color: theme.palette.secondary.A400,
  },
  '&:after': {
    borderBottom: `2px solid ${theme.palette.secondary.A400}`,
  },
});

const MuiFilledInput = {
  styleOverrides: {
    ...FingoMuiFilledInput.styleOverrides,
    root: ({ theme }) => ({
      ...FingoMuiFilledInput.styleOverrides.root({ theme }),
      [`&.${DEFAULT_FILLED_INPUT_CLASS_NAME}`]: getDefaultFilledInputStyles({ theme }),
    }),
  },
};

export default MuiFilledInput;
